import React from "react";
import { Button, Grid, withStyles } from "@material-ui/core";
import styles from "../styles";

const ActionButtons = ({
  classes,
  activeStep,
  totalSteps,
  handleBack,
  onClose,
  buttonContent,
}) => {
  return (
    <Grid container spacing={24}>
      <Grid item xs={4}></Grid>
      <Grid item xs={8} classes={{ item: classes.actionButton }}>
        {activeStep === totalSteps - 1 ? null : (
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            className={classes.button}
            id="closeButton"
          >
            Cancel
          </Button>
        )}
        {activeStep === 1 ? (
          <Button
            onClick={handleBack}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Back to Step 1
          </Button>
        ) : null}

        {buttonContent}
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(ActionButtons);
